import { getActions } from '../global';

import type { CallbackAction } from '../global/types';

const callbacks = new Map<string, number>();

// Every caller here schedules a refetch that reschedules ITSELF, so a non-positive delay is not a
// "run soon" — `setTimeout` clamps it to the next task and the action then re-arms itself on every
// tick, spinning at thousands of iterations per second. That saturates the event loop and starves
// the browser's rendering update, so the page stops painting entirely (measured on Safari: a blank
// window whose DOM was intact and whose timers still ran, but where `requestAnimationFrame` had not
// fired for minutes). Delays derived from a server timestamp go negative as soon as it passes, so
// the floor lives here rather than at each call site.
const MIN_TIMEOUT = 1000;

// TODO Pass callbacks to the master tab. Sync them on master change
export default function requestActionTimeout(action: CallbackAction, timeout: number) {
  const name = action.action;
  clearTimeout(callbacks.get(name));
  const timerId = window.setTimeout(() => {
    // @ts-expect-error -- No idea how to properly type this
    getActions()[name](action.payload);
  }, Math.max(timeout, MIN_TIMEOUT));
  callbacks.set(name, timerId);
}
